import * as React from 'react';

export const TelegramIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width={30}
    height={30}
    fill="none"
    {...props}
  >
    <path
      fill="#A84DFF"
      d="M3.842 11.828c-.813.341-1.317.949-1.325 1.809-.005.6.4 1.408 1.214 1.738.335.137 5.036.77 5.036.77s1.245 3.933 1.693 5.315c.13.4.204.597.49.858.483.442 1.3.304 1.654-.051.935-.938 2.413-2.384 2.413-2.384l.622.506s2.763 2.204 4.273 3.241c.89.612 1.506 1.25 2.507 1.253.51.002 1.327-.251 1.868-.87.357-.409.586-1.063.675-1.649.201-1.331 2.565-15.726 2.555-16.23a1.267 1.267 0 0 0-1.254-1.251c-.353.004-.644.106-1.291.304-5.007 1.528-20.798 6.502-21.13 6.64Zm18.675-3.195s-6.597 5.742-9.234 8.385c-.844.846-.904 2.299-.904 2.299l-1.363-4.36 11.501-6.324Z"
    />
  </svg>
);
